import { Icon, Label } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";

type AssessmentRoundLabelProps = {
  assessmentRound?: OpenAPI.Schemas["IdeaTemplate"]["assessments"]["rounds"][number];
  onDelete?: () => void;
};

export const AssessmentRoundLabel = ({
  assessmentRound,
  onDelete,
}: AssessmentRoundLabelProps) => {
  return (
    <Label size="tiny" image>
      {assessmentRound?.name || "Assessment"}
      {onDelete ?
        <Label.Detail
          onClick={() => {
            onDelete();
          }}
          as="a"
          aria-role="button"
        >
          <Icon name="trash" style={{ margin: 0 }} />
        </Label.Detail>
      : null}
    </Label>
  );
};
